import { Ionicons } from "@expo/vector-icons";
import { LinearGradient } from "expo-linear-gradient";
import { Stack, useRouter } from "expo-router";
import { StatusBar } from "expo-status-bar";
import { useTranslation } from "react-i18next";
import { ScrollView, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";

export default function CadeauxScreen() {
  const { t } = useTranslation();
  const router = useRouter();

  return (
    <SafeAreaView style={styles.container} edges={["top"]}>
      <StatusBar style="dark" />
      <Stack.Screen options={{ headerShown: false }} />

      <LinearGradient
        colors={["#FBEFE3", "#FFFFFF"]}
        locations={[0, 0.35]}
        style={styles.gradient}
      >
        <View style={styles.header}>
          <TouchableOpacity onPress={() => router.back()} style={styles.backButton}>
            <Ionicons name="chevron-back" size={24} color="#1C453F" />
          </TouchableOpacity>
          <Text style={styles.headerTitle}>{t("gifts.headerTitle")}</Text>
          <View style={{ width: 40 }} />
        </View>

        <ScrollView
          contentContainerStyle={styles.content}
          showsVerticalScrollIndicator={false}
        >
          <Text style={styles.intro}>
            {t("gifts.intro")}
          </Text>

          <Section title={t("gifts.drawsTitle")}>
            <Text style={styles.text}>
              {t("gifts.drawsText")}
            </Text>
          </Section>

          <View style={{ height: 40 }} />
        </ScrollView>
      </LinearGradient>
    </SafeAreaView>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <View style={styles.section}>
      <Text style={styles.sectionTitle}>{title}</Text>
      {children}
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: "#FBEFE3" },
  gradient: { flex: 1 },
  header: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: 16,
    paddingVertical: 16,
  },
  backButton: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: "#FFF",
    alignItems: "center",
    justifyContent: "center",
  },
  headerTitle: { fontFamily: "Inter_700Bold", fontSize: 18, color: "#1C453F" },
  content: { paddingHorizontal: 24, paddingTop: 8 },
  intro: {
    fontFamily: "Inter_400Regular",
    fontSize: 15,
    color: "#333",
    lineHeight: 22,
    marginBottom: 24,
  },
  section: { marginBottom: 24 },
  sectionTitle: {
    fontFamily: "Inter_700Bold",
    fontSize: 16,
    color: "#1C453F",
    marginBottom: 8,
  },
  text: {
    fontFamily: "Inter_400Regular",
    fontSize: 14,
    color: "#333",
    lineHeight: 22,
    marginBottom: 8,
  },
  bulletRow: { flexDirection: "row", paddingLeft: 8, marginBottom: 4 },
  bullet: {
    fontFamily: "Inter_400Regular",
    fontSize: 14,
    color: "#CD7728",
    marginRight: 8,
  },
  bulletText: {
    fontFamily: "Inter_400Regular",
    fontSize: 14,
    color: "#333",
    flex: 1,
    lineHeight: 20,
  },
});
